$(function() {

  if ($('#single-photo').length) {
    const $container = $('#single-photo');
    const photo = $container.data('photo');
    const profile = $container.data('instagram-profile');

    const view = new L2H.SinglePhotoView(photo, $container, {openShopableLinksInNewWindow: true});
    view.render();
  }
});
